
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.77 12.424a6.77 6.77 0 01-6.77 6.77 6.77 6.77 0 01-6.771-6.77 6.768 6.768 0 015.729-6.69V4.611h-.912a.392.392 0 01-.39-.39V2.918c0-.214.175-.39.39-.39h3.907c.214 0 .39.176.39.39v1.303c0 .214-.176.39-.39.39h-.912v1.123a6.73 6.73 0 013.245 1.452l.896-.895a.391.391 0 01.553 0l.921.921c.153.153.153.4 0 .553l-.957.957-.02.02a6.703 6.703 0 011.091 3.682zm-5.729 1.171V8.665a.392.392 0 00-.39-.39H9.347a.392.392 0 00-.39.39v4.931c0 .215.175.391.39.391h1.302c.215 0 .391-.176.391-.39z","fill":"#545F7C"}})])
          )
        }
      }
    